import { useAppSelector } from '../redux/hooks';
import { rolesArray } from '../utils/roles';

const useOrgSettings = () => {
  const orgSettings = useAppSelector((state) => state.orgDetails.data?.orgSettings);
  return orgSettings;
};

export default useOrgSettings;
